import { Stack } from "@mui/material";
import Warning from "assets/noDataWarning.png";
import Typography from "components/common/Typography";
import { tokens } from "styles/Tokens";
import { messages } from "utils/CommonConstants";

const NoPropertyPlansBanner = (props: any) => {
  return (
    <Stack
      sx={{
        backgroundColor: tokens.Background.General.Primary,
        padding: "16px",
        borderRadius: "12px",
        my: "16px"
      }}
    >
      <Stack
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{
          backgroundColor: props?.bgColor || tokens.Background.General.Secondary,
          padding: "40px 24px"
        }}
      >
        <img src={Warning} alt="No Data Warning" className="no-data-banner-icon" />
        <Typography variant="body1" color={tokens.Text.General.Tertiary}>
          {props?.message || messages.noPropertyPlans}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default NoPropertyPlansBanner;
